// action - state management
import { LOGIN, LOGOUT, REGISTER, LOGINFAILED, UPDATE_TOKENS } from './actions';

// ==============================|| ACCOUNT REDUCER ||============================== //

const initialState = {
  isLoggedIn: false,
  isInitialized: false,
  redirectFailed: false,
  user: null,
  userProfile: '',
  url: '',
  foIdtoken: ''
};

// eslint-disable-next-line
const accountReducer = (state = initialState, action) => {
  switch (action.type) {
    case REGISTER: {
      // console.log('REGISTER start');
      const { user } = action.payload;
      return {
        ...state,
        user
      };
    }
    case LOGIN: {
      // console.log('LOGIN start');
      const { user, userProfile, foIdtoken, tokens } = action.payload;
      return {
        ...state,
        isLoggedIn: true,
        isInitialized: true,
        user,
        userProfile,
        foIdtoken,
        tokens
      };
    }
    case LOGOUT: {
      // console.log('LOGOUT start');
      return {
        ...state,
        isInitialized: true,
        isLoggedIn: false,
        user: null
      };
    }
    case LOGINFAILED: {
      const redirectFailedFlg = action.payload.redirectFailedFlg;
      return {
        ...state,
        isInitialized: true,
        isLoggedIn: false,
        redirectFailed: redirectFailedFlg,
        user: null
      };
    }
    case UPDATE_TOKENS: {
      const { foIdtoken, foIdtokenRefresh } = action.payload;
      // console.log('UPDATE_TOKENS start');
      // console.log('state', { ...state });
      return {
        ...state,
        isLoggedIn: true, // 明示的に true を保持
        tokens: {
          ...state.tokens, // 既存のトークンを保持
          foIdtoken,
          foIdtokenRefresh
        }
      };
    }
    default: {
      return { ...state };
    }
  }
};

export default accountReducer;
